import * as React from 'react'

import EmptyResultsPlaceholder from '../../components/emptyResultsPlaceholder'
import LoadingCover from '../../components/loadingCover'
import SearchPageContentWrapper from '../../components/searchPageContentWrapper'
import { Props } from '../../containers/featurePageContainer'
import FeaturePageContent from './featurePageContent'

import * as styles from './featurePage.module.css'

interface IState {
  checkedBookmarks: boolean
}

class FeaturePage extends React.Component<Props, IState> {
  constructor(props: Props) {
    super(props)
    this.state = {
      checkedBookmarks: false
    }
  }

  public componentDidUpdate(prevProps: Props) {
    const newUserLoadAttempt =
      !prevProps.hasLoadAttempt && this.props.hasLoadAttempt

    if (
      !this.state.checkedBookmarks &&
      newUserLoadAttempt &&
      this.props.featuredItems.length > 0
    ) {
      this.props.getBookmarksForItems(
        this.props.featuredItems.map(item => item.id)
      )
      this.setState({ checkedBookmarks: true })
    }
  }

  public render() {
    const {
      featuredItems,
      location,
      experimentsReady,
      currentSite,
      isLoading,
      metadata
    } = this.props
    const hasItems = featuredItems && featuredItems.length > 0
    return (
      <article>
        <div className={styles.gridWidthSection}>
          <h1 className={styles.title}>Featured Files</h1>
          {metadata && (
            <h2 className={styles.subtitle}>{metadata.sub_heading}</h2>
          )}
        </div>
        <SearchPageContentWrapper experimentsReady={experimentsReady}>
          {isLoading && <LoadingCover />}
          {hasItems && (
            <FeaturePageContent
              featuredItems={featuredItems}
              location={location}
              currentSite={currentSite}
            />
          )}
          {!hasItems && (
            <EmptyResultsPlaceholder
              heading="Nothing exists here"
              subHeading="We couldn't find any data for this page. Please try again later."
            />
          )}
        </SearchPageContentWrapper>
      </article>
    )
  }
}

export default FeaturePage
